import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { Alert, notification } from 'antd';

export const useAttractionAvailabilityWarning = () => {
  const { shoppingCartTranslations: t } = useSelector(
    (data: RootState) => data.config.translations
  );
  const createNotification = (message = '') => {
    const key = `open${Date.now()}`;

    notification.open({
      message: (
        <Alert
          message={message || ''}
          description={t.attractionSearchFailed}
          type="warning"
          banner
          showIcon={true}
        />
      ),
      className: 'add-room-to-cart-warning',
      key,
      duration: 5,
      placement: 'bottomRight',
      style: {
        textAlign: 'center',
      },
    });
  };

  return createNotification;
};

export const useAddDynamicPackageRoomToCartWarning = () => {
  const { shoppingCartTranslations: t } = useSelector(
    (data: RootState) => data.config.translations
  );
  const createNotification = () => {
    const key = `open${Date.now()}`;

    notification.open({
      message: (
        <Alert
          message={t.roomsByRequestSubjectOfHotelAvailabilityTitle}
          description={t.roomsByRequestSubjectOfHotelAvailability}
          type="warning"
          banner
          showIcon={true}
        />
      ),
      className: 'add-room-to-cart-warning',
      key,
      duration: 5,
      placement: 'bottomRight',
      style: {
        textAlign: 'center',
      },
    });
  };

  return createNotification;
};

export const useAddAttractionToCartWarning = () => {
  const { shoppingCartTranslations: t } = useSelector(
    (data: RootState) => data.config.translations
  );
  const createNotification = () => {
    const key = `open${Date.now()}`;

    notification.open({
      message: (
        <Alert
          message={t.failedToAddAttraction}
          description={t.attractionAlreadyAdded}
          type="warning"
          banner
          showIcon={true}
        />
      ),
      className: 'add-room-to-cart-warning',
      key,
      duration: 5,
      placement: 'bottomRight',
      style: {
        textAlign: 'center',
      },
    });
  };

  return createNotification;
};

export const useAddRoomToCartWarning = () => {
  const { shoppingCartTranslations: t } = useSelector(
    (data: RootState) => data.config.translations
  );
  const createNotification = ({
    customDescription,
  }: {
    customDescription?: string;
  }) => {
    const key = `open${Date.now()}`;

    notification.open({
      message: (
        <Alert
          message={t.roomsByRequestSubjectOfHotelAvailabilityTitle}
          description={
            customDescription || t.roomsByRequestSubjectOfHotelAvailability
          }
          type="warning"
          banner
          showIcon={true}
        />
      ),
      className: 'add-room-to-cart-warning',
      key,
      duration: 5,
      placement: 'bottomRight',
      style: {
        textAlign: 'center',
      },
    });
  };

  return createNotification;
};

export const useAddEventToCartWarning = () => {
  const { shoppingCartTranslations: t } = useSelector(
    (data: RootState) => data.config.translations
  );
  const createNotification = () => {
    const key = `open${Date.now()}`;

    notification.open({
      message: (
        <Alert
          message={t.failedToAddEventTicket}
          description={t.eventTicketAlreadyAdded}
          type="warning"
          banner
          showIcon={true}
        />
      ),
      className: 'add-room-to-cart-warning',
      key,
      duration: 5,
      placement: 'bottomRight',
      style: {
        textAlign: 'center',
      },
    });
  };

  return createNotification;
};

export const useEventTicketPaxMismatchWarning = () => {
  const { shoppingCartTranslations: t } = useSelector(
    (data: RootState) => data.config.translations
  );
  const createNotification = () => {
    const key = `open${Date.now()}`;

    notification.open({
      message: (
        <Alert
          message={t.eventTicketPaxMismatchTitle}
          description={t.eventTicketPaxMismatch}
          type="warning"
          banner
          showIcon={true}
        />
      ),
      className: 'add-room-to-cart-warning',
      key,
      duration: 5,
      placement: 'bottomRight',
      style: {
        textAlign: 'center',
      },
    });
  };

  return createNotification;
};